import { render, staticRenderFns } from "./redEnvelopesSetting.vue?vue&type=template&id=4f1149fc&scoped=true"
import script from "./redEnvelopesSetting.vue?vue&type=script&lang=js"
export * from "./redEnvelopesSetting.vue?vue&type=script&lang=js"
import style0 from "./redEnvelopesSetting.vue?vue&type=style&index=0&id=4f1149fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1149fc",
  null
  
)

export default component.exports